import { Form } from '@anytag/shared-atoms';
import { SignUpFormSchema } from './schema';
import { Template } from './Template';
import { SignUpFormProps, SignUpFormValues } from './types';

export const SignUpForm = ({
  onSubmit,
  defaultValues = { name: '', email: '', countryId: '', companyUrl: '', companyName: '', phoneNumber: '' }
}: SignUpFormProps) => (
  <Form.Provider
    onSubmit={onSubmit}
    zodSchema={SignUpFormSchema}
    defaultValues={defaultValues}
    className="w-full rounded-none"
  >
    <Template className="mx-auto w-107" />
  </Form.Provider>
);

export { type SignUpFormValues };
